export const createReducerWithName = (
  name,
  reducer,
  initialState,
) => (state = initialState, action) => {
  if (action.name !== name) {
    return state;
  }
  return reducer(state, action);
};
